import { render, staticRenderFns } from "./SBEmergencyContacts.vue?vue&type=template&id=3cd44ae3"
import script from "./SBEmergencyContacts.vue?vue&type=script&lang=js"
export * from "./SBEmergencyContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports